import { render, staticRenderFns } from "./quiz-scale.vue?vue&type=template&id=69effcb7"
import script from "./quiz-scale.vue?vue&type=script&lang=js"
export * from "./quiz-scale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports